import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import MissionVision from './components/MissionVision';
import CTA from './components/CTA';
import Footer from './components/Footer';
import './index.css';

function App() {
  return (
    <div className="font-sans antialiased text-gray-900 bg-white selection:bg-primary selection:text-white overflow-x-hidden">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <WhyChooseUs />
      <MissionVision />
      <CTA />
      <Footer />
    </div>
  );
}

export default App;
